import CryptoJS from 'crypto-js'
// 默认的 KEY 与 iv 如果没有给
const KEY = CryptoJS.enc.Utf8.parse("CE7BC10E203C4B3696B6C600");
const IV = CryptoJS.enc.Utf8.parse('sxwh456789qwerty');
const KEY3DES = 'Q02BB7GH4JDB4A838033TANY'
/**
 * AES加密 ：字符串 key iv  返回base64
 */
export function Encrypt (word, keyStr, ivStr) {
    let key = KEY
    let iv = IV
    if (keyStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr);
        iv = CryptoJS.enc.Utf8.parse(ivStr);
    }

    let srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

}
export function Decrypt (word, keyStr, ivStr) {
    let key = KEY
    let iv = IV

    if (keyStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr);
        iv = CryptoJS.enc.Utf8.parse(ivStr);
    }

    let base64 = CryptoJS.enc.Base64.parse(word);
    let src = CryptoJS.enc.Base64.stringify(base64);

    var decrypt = CryptoJS.AES.decrypt(src, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    });

    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}


// 3DES加密
export function Encrypt3des (message) {
    message = JSON.stringify(message)
    let key = KEY3DES
    var keyHex = CryptoJS.enc.Utf8.parse(key);
    var encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();

}

// 3DES解密
export function Decrypt3des (word) {
    let key = KEY3DES
    var keyHex = CryptoJS.enc.Utf8.parse(key);
    var decrypted = CryptoJS.TripleDES.decrypt(word, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);

}
//MD5加密
function encryptMd5(word) {
    let encrypted = CryptoJS.MD5(word)
    return encrypted.toString()
}

// 3DES加密 header
export function Encrypt3des2 (message) {
    message = message.toString()
    let key = KEY3DES
    var keyHex = CryptoJS.enc.Utf8.parse(key);
    var encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();

}


 



//md5 加密签名 请求头
export function SignExtension(uid, token) {
    let key = KEY3DES
    //拼接签名数据
    let timeStamp = Date.now() 
    console.log(timeStamp)
    let string =
        timeStamp.toString() +key.toUpperCase()
    let arr = string.split('')
    arr.sort()
    let arrStr = arr.join('')
    let md5 = encryptMd5(arrStr).toUpperCase() 
    return {
        Signature: Encrypt3des2(md5),
        timeStamp:Encrypt3des(timeStamp),
        identification:'77',
        'Content-Type':'application/json;charset=utf-8'
    }
}

